var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.length > 1)?_c('div',[_c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1):_c('div',{staticClass:"uniqueChoise"},[_vm._v(_vm._s(_vm.options[0]?.text ?? _vm.options[0] ?? ''))])
}
var staticRenderFns = []

export { render, staticRenderFns }